<template>
  <div class="m_container">
    <Header :title="examInfo.organizer" />
    <section class="m_section">
      <!-- banner -->
      <swiper v-if="examBannerList.length > 0" ref="mySwiper" :options="swiperOption" class="my-swipe">
        <swiper-slide v-for="item in examBannerList" :key="item.id" class="swiper-item">
          <img class="swiper-img" :src="item.thumb_url" alt="">
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination" />
      </swiper>
      <!-- 文章 -->
      <ul class="news_wrap">
        <li class="news_item" @click="toDetail">
          <pre class="description" v-html="examInfo.content" />
          <p class="tip">阅读全文>></p>
        </li>
      </ul>
    </section>
    <TabBar :current-tab="currentTab" />
  </div>
</template>

<script>
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import { getSid, setSid } from '@/utils/cookies'
import { mapGetters } from 'vuex'

export default {
  name: 'HomeExam',
  components: { Header, TabBar },
  data() {
    return {
      sid: this.$route.query.sid ? this.$route.query.sid : getSid(),
      currentTab: 'homeExam',
      swiperOption: {
        pagination: '.swiper-pagination', // 参数选项,显示小点
        loop: true, // 循环
        autoplay: 2000, // 每张播放时长3秒，自动播放
        speed: 1000 // 滑动速度
      }
    }
  },

  computed: {
    ...mapGetters(['examInfo', 'examBannerList'])
  },

  created() {
    this.sid ? setSid(this.sid) : ''
  },

  methods: {
    toDetail() {
      this.$router.push({ path: '/examArticleDetail', query: { sid: this.sid }})
    }
  }
}
</script>

<style lang="less" scoped>
.m_container{
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .m_section {

    .my-swipe {
      overflow:hidden;
      width: 100%;
      height:200px;
      background :#f5f5f5;

      /deep/ .swiper-item{
        width:100%;
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;

        .swiper-img{
          width: 100%;
          height: 100%;
        }
      }
    }

    .news_wrap{
      padding-top: 10px;
      background: #fff;

      .news_item{
        padding:  6px 16px;
        font-size: 14px;
        text-align: left;
        line-height: 24px;
        border-bottom: 1Px solid #f5f5f5;
        color:#999;

        h3{
          color: #333;
          font-size:18px;
          padding-bottom: 10px;
        }

        .description{
          height: 48px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .tip{
          text-align: right;
          padding: 8px 0;
          color: red;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
